import {
  ExecuteCommandArgsCsv,
  LinkToSynopticArgsCsv,
  ShowTooltipArgsCsv,
  SynopticElementEventCsvConfiguration,
  SynopticElementStateCsvConfiguration,
  SynopticElementStaticCsvConfiguration
} from '../../../../model/synoptics/synoptic-configuration-csv-types';
import {ShowPopupArgsCsv} from '../../../../model/synoptics/synoptic-arg-types';

export class SynopticConfigCsvTemplate {
  public static generateDefaultArgs(modifierType: any): any {
    let args: any;
    switch (modifierType.value) {
      case 'replaceTextValue':
        args = {
          decimalPlaces: 2,
          showUnits: true,
          conversionFactor: 'number',
          conversionFactorOperation: 'addition/subtraction/division/multiplication'
        };
        return {
          sensorIdentifier: {
            entityType: 'assetMeasurement/deviceMeasurement/kpi',
            entityIdentifier: 'assetAlias/deviceSerialNumber/kpiAlias',
            sensorName: 'sensorName - Only device or asset'
          },
          args: args
        } as SynopticElementStateCsvConfiguration;
      case 'styleByThresholds':
        args = {
          thresholds: [{
            from: 0,
            to: 5,
            backgroundColor: '#333333',
            widthPercentage: 5,
            heightPercentage: 5,
            opacityPercentage: 100,
            visible: true
          }],
          attributes: ['backgroundColor', 'widthPercentage', 'heightPercentage', 'visibility'],
          originAnchor: 'top left | top center | top right | center left | center center | center right | bottom left | bottom center | bottom right',
          defaultStyle: {"backgroundColor": "#333333","widthPercentage": 5,"heightPercentage": 5,"opacityPercentage": 100,"visible": true}
        };
        return {
          sensorIdentifier: {
            entityType: 'assetMeasurement/deviceMeasurement/kpiMeasurement',
            entityIdentifier: 'assetAlias/deviceSerialNumber/kpiAlias',
            sensorName: 'sensorName - Only device or asset'
          },
          args: args
        } as SynopticElementStateCsvConfiguration;
      case 'styleByContinuousValue':
        args = {
          valueRange: [0, 100],
          backgroundColorRange: ['#333333', '#407ec9'],
          widthPercentageRange: [0, 100],
          heightPercentageRange: [0, 100],
          opacityPercentageRange: [0, 100],
          attributes: ['backgroundColor', 'widthPercentage', 'heightPercentage', 'opacityPercentage'],
          originAnchor: 'top left | top center | top right | center left | center center | center right | bottom left | bottom center | bottom right'
        };
        return {
          sensorIdentifier: {
            entityType: 'assetMeasurement/deviceMeasurement/kpiMeasurement',
            entityIdentifier: 'assetAlias/deviceSerialNumber/kpiAlias',
            sensorName: 'sensorName - Only device or asset'
          },
          args: args
        } as SynopticElementStateCsvConfiguration;
      case 'showPopup':
        args = {component: null, file: null} as ShowPopupArgsCsv;
        return {trigger: 'click', args: args} as SynopticElementEventCsvConfiguration;
      case 'executeCommand':
        args = {
          deviceSerialNumber: 'deviceSerialNumber',
          schema: 'schemaName',
          command: 'commandName',
          params: null,
          askParamsToUser: false
        } as ExecuteCommandArgsCsv;
        return {trigger: 'click', args: args} as SynopticElementEventCsvConfiguration;
      case 'closePopup':
        return {trigger: 'click', args: {}} as SynopticElementEventCsvConfiguration;
      case 'showTooltip':
        args = {
          rows: [{
            label: 'label',
            value: {
              entityType: 'assetMeasurement/deviceMeasurement/kpi',
              entityIdentifier: 'assetAlias/deviceSerialNumber/kpiAlias',
              sensorName: 'sensorName - Only device or asset'
            }
          }], showDates: false, title: 'Title'
        } as ShowTooltipArgsCsv;
        return {trigger: 'hover', args: args} as SynopticElementEventCsvConfiguration;
      case 'linkToSynoptic':
        args = {synopticName: 'synopticName'} as LinkToSynopticArgsCsv;
        return {trigger: 'click', args: args} as SynopticElementEventCsvConfiguration;
      case 'text':
        return {value: 'value'} as SynopticElementStaticCsvConfiguration;
    }
  }
}
